/**
 * GA4 event helper — conversion events for the MARKETING property.
 *
 * The portal dual-tags two GA4 properties (public/index.html): G-60PVSEEEWE
 * (product analytics) and G-VWTFSBKL65 (the marketing property that Google Ads
 * imports conversions from). Events fired here go to BOTH — gtag events
 * without `send_to` fan out to every configured property, which is what we
 * want: Ads reads them from G-VWTFSBKL65, and having them in the product
 * property too costs nothing.
 *
 * Never throws and never blocks: if gtag is absent (ad blocker, script
 * failure, test environment) the event is silently dropped — analytics must
 * not be able to break signup or checkout.
 */
export function gaEvent(name, params = {}) {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    }
  } catch {
    /* analytics must never break the flow it measures */
  }
}
